module.exports = __webpack_public_path__ + "img/dpd.1f29e88c.png";